module.exports = __webpack_public_path__ + "static/media/well.57224be5.png";